import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const offerApiUrl = `${baseApiUrl}/api/OfferTypes`;

export async function getOfferById(id) {
  return await httpRequest(fetchOfferById.bind(this, id));
}
async function fetchOfferById(id) {
  let config = getHttpHeaders();
  return await axios.get(`${offerApiUrl}/${id}`, config);
}

export async function getOfferLists() {
  return await httpRequest(fetchOffers.bind(this));
}

async function fetchOffers() {
  let config = getHttpHeaders();
  return await axios.get(
    `${offerApiUrl}`,
    config
  );
}

export async function addOffer(offer) {
  return await httpRequest(postOffer.bind(this, offer));
}

async function postOffer(offer) {
  let config = getHttpHeaders();
  return await axios.post(`${offerApiUrl}`, offer, config);
}

export async function updateOffer(offer) {
  return await httpRequest(putOffer.bind(this, offer));
}

async function putOffer(offer) {
  let config = getHttpHeaders();
  return await axios.put(`${offerApiUrl}`, offer, config);
}

export async function deleteOffer(id) {
  return await httpRequest(removeOffer.bind(this, id));
}

async function removeOffer(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${offerApiUrl}/${id}`, config);
}
